export default {
  invoiced: {
    title: {
      invocied: "Invoiced",
      transactions: "Invoiced Transactions",
    },
    table: {
      line_number: "Line Number",
      dealer_code: "Dealer Code",
      dealer_name: "Dealer Name",
      product_code: "Product Code",
      product_packaging: "Product Packaging",
      qty: "Qty",
      sales: "Sales",
      discount: "Discount",
      sales_after_discount: "Sales After Discount",
      date: "Date",
      invoice_no: "Invoice No",
      country: "Country",
      item_class_id: "Item Class Id",
    },
    fields: {
      name: "Name",
      type: "Type",
      start: "Start",
      end: "End",
      active: "Active",
      batchId: "Batch ID",
      upload_date: "Upload Date",
      totalItems: "Total Items",
    },
    messages: {
      invoice_delete: "Element Deleted",
      try_again: "Please try again",
    },
  },
};
